<template>
  <vxe-grid
    auto-resize
    highlight-hover-row
    :data="tableData"
    :toolbar-config="tableToolbar"
    :columns="tableColumns"
    :loading="loading"
    :height="500"
    size="mini"
    resizable
    border
    round
    row-id="orderTechPricingSpecCode"
    :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    :radio-config="{
      highlight: true,
      trigger: 'row',
      reserve: true,
      strict: true,
    }"
    @radio-change="(e) => $emit('radio-change', e)"
  >
    <template v-slot:toolbar_form>
      <slot name="header"></slot>
    </template>
    <template v-slot:pager>
      <slot name="pager"></slot>
    </template>
    <template v-slot:displayModify="{ row }">
      <div>{{ row.modifyByName }}</div>
      <div>{{ row.modifyTime }}</div>
    </template>
  </vxe-grid>
</template>
<script>
import tableColumns from './table-columns'
import { format } from '@/libs/util.number.js'

export default {
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    tablePage: { type: Object, default: () => {} },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
      },
      tableColumns: tableColumns(this),
      format: (number) => format(number),
    }
  },
}
</script>
